import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
};

const Form = props => {
  return <form {...props} />;
};

Form.propTypes = propTypes;

export default Form;
